// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>30</span>&nbsp;&nbsp;Trample down those who lust after silver;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;scatter the peoples that delight in war.<br> </p> </div></div>";
// Exports
module.exports = code;